export default [
  { label: 'Facebook Groups', value: 'Facebook Groups' },
  { label: 'Instagram', value: 'Instagram' },
  { label: 'Google Search', value: 'Google Search' },
  { label: 'YouTube Video', value: 'YouTube Video' },
  { label: 'Our Blog', value: 'Our Blog' },
  { label: 'Other', value: 'Other' }
];
